export default __webpack_public_path__ + "static/media/insta1.819be696.jpg";